export enum Steps {
	BANK_AND_RECEIPT_TYPE_DATA = "bankAndReceiptTypeData",
	RECEIPT_DATA = "receiptData",
	CUSTOMER_DATA = "customerData",
	SUMMARY = "summary"
}
